import { Stack, Text, VStack } from '@genial/components';
import { Utils } from '@genial/utils';
import React from 'react';

import { TextWithSubtextSkeleton } from '../../../../../AssetsLoading';
import { FixedIncomeSharedInfoTypes, FixedIncomeSharedInfoTypesLoading } from '../types';

export const FeeInfo: React.FC<FixedIncomeSharedInfoTypes> = ({
  selectedFee,
  estimatedIncomeCalculated,
  w,
}) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Fee</Text>
        <Text>{selectedFee?.honorariumFee || '--'}</Text>
        <Text color="neutral.dark" fontSize="xs">
          Receita Estim.: {Utils.Mask.Money(estimatedIncomeCalculated)}
        </Text>
      </VStack>
    </Stack>
  );
};

export const FeeInfoLoading: React.FC<FixedIncomeSharedInfoTypesLoading> = ({ w }) => {
  return (
    <Stack w={w}>
      <VStack space="stack.quarck" justifyContent="space-between">
        <Text variant="semibold">Fee</Text>
        <TextWithSubtextSkeleton />
      </VStack>
    </Stack>
  );
};
